The button details for initiating verification.
